import { heroStats, quickEntries } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20editorial%20backdrop%20with%20dramatic%20spotlight%20beams%20and%20crimson%20amber%20glow%20on%20charcoal%20surface%2C%20film%20grain%20texture%2C%20cinematic%20moody%20atmosphere%2C%20high%20contrast%2C%20minimal%20composition%2C%20no%20people&width=1600&height=900&seq=hl-hero-2026&orientation=landscape"
          alt="31黑料网黑料专题聚合页封面"
          title="31黑料网黑料专题 黑料专区 黑料频道 黑料导航"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-transparent" />
      </div>

      <div className="relative mx-auto w-full max-w-shell px-4 py-20 md:px-6 md:py-32">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
          <div className="w-full max-w-2xl animate-hl-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3.5 py-1.5 text-xs font-label tracking-wide text-white/90 backdrop-blur">
              <i className="ri-bookmark-3-line text-primary-300" />
              黑料专题 · 黑料专区 · 一站直达
            </span>

            <h1 className="mt-6 font-heading text-4xl font-bold leading-[1.15] text-white md:text-6xl">
              31黑料网
              <span className="mt-2 block text-2xl font-semibold text-white/80 md:text-4xl">
                黑料专题聚合，一页看全脉络
              </span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-white/75 md:text-base">
              聚合<span className="text-primary-300">31黑料网黑料专题</span>、
              <span className="text-primary-300">31黑料网黑料专区</span>、
              <span className="text-primary-300">31黑料网黑料频道</span>与
              <span className="text-primary-300">31黑料网黑料导航</span>，
              一站直达最新爆料内容，深挖事件脉络不迷路。
            </p>

            <div className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
              <div className="flex flex-1 items-center gap-2 rounded-md border border-white/20 bg-white/95 px-4 py-3">
                <i className="ri-search-2-line text-base text-foreground-400" />
                <input
                  type="text"
                  placeholder="搜索黑料专题 / 专区 / 频道"
                  className="w-full bg-transparent text-sm font-label text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
              <a
                href="#topics"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label font-medium text-background-50 transition-colors duration-300 hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
              >
                <i className="ri-flashlight-line text-base" />
                直达专题
              </a>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-2.5">
              {quickEntries.map((entry) => (
                <a
                  key={entry.href}
                  href={entry.href}
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-white/20 bg-white/5 px-3.5 py-1.5 text-xs font-label text-white/85 transition-colors duration-300 hover:border-primary-300/60 hover:text-white cursor-pointer"
                >
                  <i className={`${entry.icon} text-sm text-primary-300`} />
                  {entry.label}
                </a>
              ))}
            </div>
          </div>

          <div className="w-full max-w-sm animate-hl-float">
            <div className="rounded-lg border border-white/15 bg-white/10 p-6 backdrop-blur-md">
              <div className="flex items-center justify-between">
                <span className="text-sm font-label font-medium text-white">今日收录概览</span>
                <span className="inline-flex items-center gap-1.5 text-[11px] font-label text-white/60">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-hl-pulse" />
                  滚动更新
                </span>
              </div>

              <div className="mt-5 grid grid-cols-2 gap-3">
                {heroStats.map((stat) => (
                  <div
                    key={stat.label}
                    className="rounded-md border border-white/10 bg-black/25 px-4 py-3.5"
                  >
                    <div className="font-heading text-2xl font-bold text-accent-400">
                      {stat.value}
                      <span className="text-base">{stat.suffix}</span>
                    </div>
                    <div className="mt-1 text-xs font-label text-white/65">{stat.label}</div>
                  </div>
                ))}
              </div>

              <a
                href="#download"
                className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/20 bg-white/10 px-4 py-3 text-sm font-label text-white transition-colors duration-300 hover:bg-white/20 cursor-pointer"
              >
                <i className="ri-download-2-line text-base text-accent-400" />
                下载入口 · 随时查看更新
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}